import React from 'react'

const BlankLayout = props =>
  <React.Fragment>
    {props.children}
  </React.Fragment>

export default BlankLayout
